import * as React from 'react';
import {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {Link} from "react-router-dom";
import {MenuItem} from "../../types";
import {getFeatures} from "../../api";

const Navigation: React.FunctionComponent = () => {


    let location = useLocation();
    const [menuItems, setMenuItems] = useState<MenuItem[]>([]);

    const getMenuItemById = (id: string) => {
        if (id === "clients") {
            return {
                label: "Clients",
                path: "/m/clients",
                weight: 1,
                menuItems: [],
                icon: ""
            }
        }
        if (id === "therapy-sessions") {
            return {
                label: "Therapy Sessions",
                path: "/m/therapy-sessions",
                weight: 10,
                menuItems: [],
                icon: ""
            }
        }
        if (id === "users") {
            return {
                label: "Users",
                path: "/m/users",
                weight: 20,
                menuItems: [],
                icon: ""
            }
        }
        if (id === "document-templates") {
            return {
                label: "Document Templates",
                path: "/m/templates",
                weight: 20,
                menuItems: [],
                icon: ""
            }
        }
        return {
            label: id,
            path: "/m/clients",
            weight: 20,
            menuItems: [],
            icon: ""
        }
    }

    useEffect(() => {

        getFeatures()
            .then((fs) => {
                let items: MenuItem[] = [];
                fs.forEach((f) => {
                    items.push(getMenuItemById(f.name));
                });
                setMenuItems(items.sort(function (a, b) {
                    return a.weight - b.weight;
                }));
            })

        // let mi = new Array<MenuItem>();
        // mi.push({
        //         label: "Clients",
        //         path: "/m/clients",
        //         weight: 1,
        //         menuItems: [],
        //         icon: ""
        //     },
        //     {
        //         label: "Therapy Sessions",
        //         path: "/m/therapy-sessions",
        //         weight: 10,
        //         menuItems: [],
        //         icon: ""
        //     },
        //     {
        //         label: "Users",
        //         path: "/m/users",
        //         weight: 20,
        //         menuItems: [],
        //         icon: ""
        //     }, {
        //         label: "Document Templates",
        //         path: "/m/templates",
        //         weight: 20,
        //         menuItems: [],
        //         icon: ""
        //     });


        // setMenuItems(mi.sort(function (a, b) {
        //     return a.weight - b.weight;
        // }));
    }, []);


    return (
        <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
            <div className="sidebar-sticky pt-3">
                <ul className="nav flex-column">

                    {
                        menuItems.map((g, gindex) => (<React.Fragment key={"g_" + gindex}>
                            {
                                (Array.isArray(g.menuItems) && g.menuItems.length) ?
                                    <>
                                        <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                                            <span>{g.label}</span>
                                        </h6>
                                        {g.menuItems.map((u, uindex) => (<li key={"nav_" + uindex} className="nav-item">
                                            <Link
                                                className={"nav-link" + ((location.pathname.startsWith(u.path)) ? " active" : "")}
                                                to={u.path}>
                                                <span data-feather="layers"></span>
                                                {u.label}
                                            </Link>
                                        </li>))}
                                    </>
                                    :
                                    <li>
                                        <Link
                                            className={"nav-link" + ((location.pathname.startsWith(g.path)) ? " active" : "")}
                                            to={g.path}>
                                            <span data-feather="layers"></span>
                                            {g.label}
                                        </Link>
                                    </li>
                            }

                        </React.Fragment>))

                    }

                </ul>

            </div>
        </nav>
    );
};

export default Navigation;